import Cookies from "universal-cookie";
import { getEnv } from "../../env";

const cookies = new Cookies();

const theme = cookies.get("theme") || getEnv("REACT_APP_DEFAULT_THEME");
const language =
  cookies.get("language") || getEnv("REACT_APP_DEFAULT_LANGUAGE");

const initState = {
  settings: {
    theme,
    language,
  },
  project: null,
  projects: [],
};

const appReducer = (state = initState, action) => {
  switch (action.type) {
    case "UPDATE_THEME": {
      if (action.theme === state.settings.theme) return state;

      const settings = { ...state.settings };

      settings.theme = action.theme;

      cookies.set("theme", action.theme, {
        path: "/",
        sameSite: "strict",
        maxAge: 31536000, //a year
      });

      return { ...state, settings };
    }
    case "SET_LANG": {
      if (action.language === state.settings.language) return state;

      const settings = { ...state.settings };

      settings.language = action.language;

      cookies.set("language", action.language, {
        path: "/",
        sameSite: "strict",
        maxAge: 31536000, //a year
      });

      return { ...state, settings };
    }
    case "SET_PROJECT": {
      if (action.project)
        localStorage.setItem(
          `project-${action.user}`,
          JSON.stringify(action.project),
        );
      else localStorage.removeItem(`project-${action.user}`);
      return { ...state, project: action.project };
    }
    case "SET_PROJECTS": {
      return { ...state, projects: action.projects || [] };
    }
    default:
      return state;
  }
};

export default appReducer;
